import React, { useEffect, useRef, useState } from "react";
import i18n from "i18next";

// Fluent UI Imports
import {
  AddRegular,
  ArrowDownloadRegular,
  ArrowRotateClockwiseRegular,
  DismissRegular,
  InfoRegular,
  Print24Regular,
  SubtractRegular,
} from "@fluentui/react-icons";
import {
  Button,
  DataGrid,
  DataGridBody,
  DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
  Divider,
  Field,
  Label,
  makeStyles,
  MessageBar,
  ProgressBar,
  Text,
} from "@fluentui/react-components";

// Pdf Viewer
import { Document, Page } from "react-pdf";

import useWindowSize from "../helpers/useWindowSize";
import { IStuelipos } from "../Models/IStuelipos";
import { baseUrl } from "../helpers/constants";
import { fetchWrapper } from "../helpers/fetchwrapper";
import { IStueli } from "../Models/IStueli";
import AddToBedarfDialog from "../components/Account/Bedarfe/AddToBedarfDialog";
import { PDFPageProxy } from "react-pdf/dist/Page";

import { StackShim } from "@fluentui/react-migration-v8-v9";
import { BOMColumns } from "../components/ProductDetails/BOMColumns";
import { IAddUserBedarfPosition } from "../Models/IAddUserBedarfPosition";

//import { pdfjs } from "react-pdf";
//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const pdfViewerContentStyles = makeStyles({
  header: {
    flex: "1 1 auto",
    borderTop: `3px solid #ff6600`,
    borderBottom: `1px solid #b3b3b3`,
    display: "flex",
    alignItems: "center",
    fontWeight: "semibold",
    padding: "  12px 10px",
  },

  body: {
    background: "#f2f2f2",
    position: "relative",
    overflow: "auto",
    flex: "4 4 auto",

    selectors: {
      p: { margin: "14px 0" },
      "p:first-child": { marginTop: 0 },
      "p:last-child": { marginBottom: 0 },
    },
  },
});

interface IDocumentPdfViewerProps {
  onDismiss: any;
  title: string;
  path: string;
  stueliId?: string | undefined;
  addToBedarf?: any;
  canDownload: boolean;
}

function DocumentPdfViewer(props: IDocumentPdfViewerProps) {
  //---------------------USESTATES--------------------
  // seiten Rotation
  const [rotate, setRotate] = useState<number>(0);
  // Gibt den Akutellen Seitenzahl an
  const [pageValue, setPageValue] = useState<number>(1);
  //Gibt den Zoom Wert an der auf das PDF wirkt
  const [zoomValue, setZoomValue] = useState<number>(100);
  //Gibt die Breite des PDFs an
  const [pageWidth, setPageWidth] = useState<number>(0);
  //Gibt den Anfangs Breite des PDFs an
  const [startPageWidth, setStartPageWidth] = useState<number>(0);
  //Wenn kein PDF gefunden wird dann wird es auf true gesetzt
  const [pdfError, setPdfError] = useState(false);
  //Anzahl der Seiten
  const [numPages, setNumPages] = useState(0);
  //Array mit so vielen leeren Feldern wie Seiten Anzahl es gibt (für das Mapping genutzt)
  const [pagesArray, setPagesArray] = useState<number[]>([]);
  //Objekt Liste der Stücklistenbestandteile
  const [stueli, setStueli] = useState<IStueli | undefined>(undefined);

  const [addToBedarf, setAddToBedarf] = useState<
    IAddUserBedarfPosition | undefined
  >(undefined);
  //Refs Objekt in dem die Refs gespeichert werden von den Elementen
  const pageRefs = useRef(new Array());

  //Ref Objekt für das Drucken

  // let refPrint = useRef<any>(null);

  const [pdf, setPdf] = useState<any>(undefined);
  //--------------------------------------------------

  //---------------------USEEFFECTS-------------------
  //pagesArray wird hier gefüllt
  useEffect(() => {
    const _pagesArray = [];
    for (let i = 1; i <= numPages; i++) {
      _pagesArray.push(i);
    }
    setPagesArray(_pagesArray);
  }, [numPages]);

  useEffect(() => {
    setRotate(0); //Reset
    pageRefs.current = []; // Reset
    setZoomValue(100); //Reset
    setPageValue(1); //Reset
    setNumPages(0); //Reset
  }, [props.path]);

  useEffect(() => {
    if (props.stueliId && props.stueliId != "") {
      getStueli(props.stueliId);
    } else {
      setStueli(undefined);
    }
  }, [props.stueliId]);

  //---------------------------------------------------
  //---------------------Styles------------------------
  const _pdfViewerContentStyles = pdfViewerContentStyles();
  //---------------------------------------------------
  //---------------------METHODEN----------------------
  const getStueli = (artikelId: string) => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/bom/getbom?artikelId=${artikelId}`)
      .then((data: IStueli) => {
        data.positionen = data.positionen.filter(
          (pos: IStuelipos) => pos.stueliId == artikelId
        );
        setStueli(data);
      });
  };

  const size = useWindowSize();

  const columns = BOMColumns({
    onAddBedarf: (item: IAddUserBedarfPosition) => {
      setAddToBedarf(item);
    },
    showExpandButton: false,
    showPdfViewerButton: false,
  });

  window.addEventListener(
    "wheel",
    (event) => {
      const { ctrlKey } = event;
      if (ctrlKey) {
        event.preventDefault();
        return;
      }
    },
    { passive: false }
  );

  //---------------------------------------------------
  //---------------------FINALLY-RETURN----------------
  return (
    <div>
      {addToBedarf != undefined && (
        <AddToBedarfDialog
          onDismiss={() => setAddToBedarf(undefined)}
          addUserBedarfPosition={addToBedarf}
        />
      )}

      {/* <Modal
        containerClassName="lueb-DisplayFlex"
        titleAriaId={props.title}
        isOpen={props.path != ""}
        onDismiss={() => props.onDismiss()}
        isBlocking={true}
        layerProps={{ eventBubblingEnabled: true }}
        styles={{ main: { width: "80%" } }}
      > */}

      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            position: "relative",
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "20px",
            /* boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", */
            width: "80%",
          }}
        >
          <div
            style={{ touchAction: "manipulation" }}
            //Bei Tasten-Kombination zoomen
            onWheel={(ev) => {
              if (ev.ctrlKey == true) {
                if (ev.deltaY > 1 && zoomValue > 60) {
                  setPageWidth((startPageWidth / 100) * (zoomValue - 20));
                  setZoomValue(zoomValue - 20);
                } else if (ev.deltaY < 1 && zoomValue < 300) {
                  setPageWidth((startPageWidth / 100) * (zoomValue + 20));
                  setZoomValue(zoomValue + 20);
                }
                ev.preventDefault();
              }
            }}
          >
            <div style={{ minHeight: 30, marginBottom: 10 }}>
              <StackShim
                horizontal
                verticalAlign="center"
                horizontalAlign={pdfError ? "end" : "space-between"}
              >
                {!pdfError && (
                  <StackShim
                    horizontal
                    verticalAlign="center"
                    tokens={{ childrenGap: 5 }}
                  >
                    <Button
                      size="large"
                      appearance="subtle"
                      icon={<InfoRegular />}
                      title={props.title}
                    />
                    {props.canDownload && (
                      <>
                        <Button
                          size="large"
                          appearance="subtle"
                          title={i18n.t<string>("print")}
                          icon={<Print24Regular />}
                          onClick={() => {
                            if (pdf) {
                              var blob = new Blob([pdf], {
                                type: "application/pdf",
                              }); //this make the magic
                              var blobURL = URL.createObjectURL(blob);
                              var iframe = document.createElement("iframe"); //load content in an iframe to print later
                              document.body.appendChild(iframe);
                              iframe.style.display = "none";
                              iframe.src = blobURL;
                              iframe.onload = function () {
                                setTimeout(function () {
                                  if (iframe && iframe.contentWindow) {
                                    iframe.focus();
                                    iframe.contentWindow.print();
                                  }
                                }, 1);
                              };
                            }
                          }}
                        />
                        <Button
                          size="large"
                          appearance="subtle"
                          icon={<ArrowDownloadRegular />}
                          title={i18n.t<string>("download")}
                          onClick={() => {
                            if (pdf) {
                              var file = new Blob([pdf], {
                                type: "application2/pdf",
                              });

                              // process to auto download it
                              const fileURL = URL.createObjectURL(file);
                              const link = document.createElement("a");
                              link.href = fileURL;
                              link.download = props.title
                                .toLowerCase()
                                .includes(".pdf")
                                ? props.title
                                : props.title + ".pdf";
                              link.click();
                            }
                          }}
                        />
                      </>
                    )}
                    <Button
                      size="large"
                      appearance="subtle"
                      title={i18n.t<string>("rotate")}
                      icon={<ArrowRotateClockwiseRegular />}
                      onClick={() => {
                        setRotate(rotate == 360 ? 90 : rotate + 90);
                      }}
                    />
                    {numPages > 1 && (
                      <div>
                        <div
                          style={{
                            width: "42px",
                            float: "left",
                            marginRight: "5px",
                            marginLeft: "10px",
                          }}
                        >
                          <Field
                            onBlur={(x) => {
                              if (x.currentTarget.nodeValue == "") {
                                setPageValue(1);
                              } else {
                                pageRefs.current[pageValue - 1].scrollIntoView({
                                  behavior: "smooth",
                                  block: "start",
                                  inline: "nearest",
                                });
                              }
                            }}
                            //Bestätigung durch Enter-Taste bei Seiten suche
                            onKeyDown={(ev) => {
                              if (ev.code == "Enter") {
                                if (ev.currentTarget.nodeValue == "") {
                                  setPageValue(1);
                                } else {
                                  pageRefs.current[
                                    pageValue - 1
                                  ].scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                    inline: "nearest",
                                  });
                                }
                              }
                            }}
                            // value={pageValue == 0 ? "" : pageValue.toString()}
                            // onChange={(ev, value) => {
                            //   if (value == "") {
                            //     setPageValue(0);
                            //   } else if (
                            //     Number(value) >= 1 &&
                            //     Number(value) <= pagesArray.length
                            //   ) {
                            //     setPageValue(Number(value));
                            //   }
                            // }}
                          />
                        </div>
                        <div
                          style={{
                            float: "left",
                            marginLeft: "3px",
                            marginTop: "4px",
                          }}
                        >
                          <Text>
                            {i18n.t("von")} {pagesArray.length}
                          </Text>
                        </div>
                      </div>
                    )}
                    <Button
                      size="large"
                      appearance="subtle"
                      style={{ marginLeft: "10px" }}
                      icon={<AddRegular />}
                      title="Plus"
                      disabled={zoomValue == 300}
                      onClick={() => {
                        setPageWidth((startPageWidth / 100) * (zoomValue + 20));
                        setZoomValue(zoomValue + 20);
                      }}
                    />
                    <Text>{zoomValue} %</Text>
                    <Button
                      size="large"
                      appearance="subtle"
                      icon={<SubtractRegular />}
                      title="Minus"
                      disabled={zoomValue == 60}
                      onClick={() => {
                        setPageWidth((startPageWidth / 100) * (zoomValue - 20));
                        setZoomValue(zoomValue - 20);
                      }}
                    />
                  </StackShim>
                )}

                <Button
                  size="large"
                  appearance="subtle"
                  title={i18n.t<string>("close")}
                  icon={<DismissRegular />}
                  onClick={() => {
                    props.onDismiss();
                  }}
                />
              </StackShim>
            </div>

            <div
              className={_pdfViewerContentStyles.body}
              style={{
                height: props.path.toLowerCase().endsWith(".pdf")
                  ? "88vh"
                  : "auto",
              }}
            >
              {props.path.toLowerCase().endsWith(".pdf") && (
                <div
                  id={"printContent"}
                  style={{
                    display: "flex",
                    margin: "0 auto",
                    alignItems: "center",
                    flexDirection: zoomValue > 100 ? "row" : "column",
                  }}
                >
                  <StackShim
                    style={{
                      display: "flex",
                      margin: "0 auto",
                      alignItems: "center",
                    }}
                  >
                    {pdfError && (
                      <div
                        style={{
                          height: props.path.toLowerCase().endsWith(".mp4")
                            ? "auto"
                            : size.height - 150,
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <MessageBar intent="error">
                          {i18n.t<string>("pdfLoadError")}
                        </MessageBar>
                      </div>
                    )}

                    {!pdfError && (
                      <Document
                        className="lueb-pdfDocument"
                        data-is-scrollable={true}
                        loading={""}
                        onLoadSuccess={(pdf) => {
                          pdf.getData().then((pdfData) => {
                            setPdf(pdfData);
                          });
                          setNumPages(pdf.numPages);
                        }}
                        onLoadError={(error: Error) => {
                          setPageWidth(
                            size.width > 500 ? 500 : size.width - 20
                          );
                          setStartPageWidth(
                            size.width > 500 ? 500 : size.width - 20
                          );
                          setPdfError(true);
                        }}
                        file={props.path}
                      >
                        {pagesArray.map((pageNum) => {
                          // if (pageRefs.current.length < numPages) {
                          return (
                            <div
                              ref={(element) => {
                                if (
                                  element &&
                                  pageRefs.current.length < numPages
                                ) {
                                  pageRefs.current.push(element);
                                }
                              }}
                              style={{
                                // display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "10px",
                              }}
                            >
                              <Page
                                renderTextLayer={false}
                                rotate={rotate}
                                onLoadSuccess={(page: PDFPageProxy) => {
                                  setPageWidth(
                                    // page.width > size.width - 20
                                    //   ? size.width - 20
                                    //   : page.width == 0
                                    //   ? 500
                                    //   : page.width

                                    (size.width / 100) * 70
                                  );

                                  setStartPageWidth(
                                    // page.width > size.width - 20
                                    //   ? size.width - 20
                                    //   : page.width == 0
                                    //   ? 500
                                    //   : page.width
                                    (size.width / 100) * 70
                                  );
                                  // Hier wird die Zoomfuntion vom Browser blockiert
                                  const myDiv =
                                    document.getElementById("test3454");
                                  if (myDiv) {
                                    myDiv.addEventListener(
                                      "wheel",
                                      function (e) {
                                        if (e.ctrlKey) {
                                          e.preventDefault();
                                        }
                                      },
                                      {
                                        passive: false,
                                      }
                                    );
                                  }
                                }}
                                renderAnnotationLayer={false}
                                height={
                                  stueli?.positionen &&
                                  stueli?.positionen?.length > 0
                                    ? size.height * 0.75
                                    : size.height - 220
                                }
                                width={pageWidth}
                                className="lueb-pdfPage"
                                pageNumber={pageNum}
                              />
                            </div>
                          );
                        })}
                      </Document>
                    )}
                    {/* ------------------Ladebalken------------------- */}
                    {pageWidth == 0 && !pdfError && (
                      <div
                        style={{
                          width: (size.width / 100) * 30,
                          height: (size.height / 100) * 80,
                          margin: "0 auto",
                        }}
                      >
                        <ProgressBar thickness="large" />
                      </div>
                    )}

                    {!pdfError &&
                      stueli?.positionen &&
                      stueli?.positionen?.length > 0 && (
                        <Divider
                          appearance="brand"
                          style={{
                            marginLeft: 10,
                            marginRight: 10,
                            marginBottom: 10,
                          }}
                        >
                          <Label>{i18n.t<string>("bom")}</Label>
                        </Divider>
                      )}

                    {/* ---------------------------------------------------- */}
                    {/* ----------------------Stückliste------------------- */}
                    {stueli?.positionen &&
                      stueli?.positionen?.length > 0 &&
                      pageWidth != 0 && (
                        <div
                          style={{
                            boxShadow:
                              "0px 0px 8px -1px rgba(158, 158, 158, 1)",
                            marginBottom: 30,
                            marginLeft: 5,
                            background: "white",
                            width: startPageWidth,
                            padding: "20px",
                          }}
                        >
                          <DataGrid
                            items={stueli?.positionen ? stueli?.positionen : []}
                            columns={columns}
                            resizableColumns={true}
                            columnSizingOptions={{
                              position: {
                                minWidth: 60,
                                defaultWidth: 60,
                              },
                              artikelId: {
                                minWidth: 100,
                                defaultWidth: 100,
                              },
                              isVerschleissteil: {
                                minWidth: 60,
                                defaultWidth: 60,
                              },
                              menge: {
                                minWidth: 60,
                                defaultWidth: 60,
                              },
                              benennung: {
                                minWidth: 190,
                                defaultWidth: 500,
                              },
                              actions: {
                                minWidth: 60,
                                defaultWidth: 60,
                              },
                            }}
                          >
                            <DataGridHeader>
                              <DataGridRow>
                                {({ renderHeaderCell }) => (
                                  <DataGridHeaderCell>
                                    {renderHeaderCell()}
                                  </DataGridHeaderCell>
                                )}
                              </DataGridRow>
                            </DataGridHeader>
                            <DataGridBody<IStuelipos>>
                              {({ item, rowId }) => (
                                <DataGridRow<any> key={rowId}>
                                  {({ renderCell }) => (
                                    <DataGridCell>
                                      {renderCell(item)}
                                    </DataGridCell>
                                  )}
                                </DataGridRow>
                              )}
                            </DataGridBody>
                          </DataGrid>
                        </div>
                      )}
                  </StackShim>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DocumentPdfViewer;
